import { Component } from "vue-property-decorator";
import { EntityListProvider } from "~shared/classes/entity-list.provider";
import { IdentityProvidersModel } from "@flosum-auth/contracts";
import { InjectService } from "~shared/decorators/inject-service.decorator";
import { IdentityProvidersService } from "@/modules/identity-providers/services/identity-providers.service";
import { DEFAULT_PAGINATION_LIMIT } from "~shared/shared.constants";

@Component({})
export class IdentityProvidersListProvider extends EntityListProvider {
  @InjectService()
  private $identityProvidersService!: IdentityProvidersService;

  private columns: (keyof IdentityProvidersModel)[] = ["id", "name", "active", "createdAt", "updatedAt"];

  public mounted(): void {
    this.onSearchOptionsChanged().catch(() => null);
  }

  public async onSearch(): Promise<{ items: unknown[]; total: number } | null> {
    try {
      const { identityProviders, total } = await this.$identityProvidersService.find({
        columns: this.columns,
        searchText: this.searchValue,
        limit: DEFAULT_PAGINATION_LIMIT,
        offset: DEFAULT_PAGINATION_LIMIT * (this.page - 1),
      });

      return {
        items: identityProviders,
        total,
      };
    } catch ({ message }) {
      this.$notify({
        type: "error",
        text: message as string,
      });
      return null;
    }
  }
}
